const initialState = {
    missionOpen: null,
    missionName: '',
    exitMissionModal: false,
    statusMissions: null,
    seasonPassSelecting: false,
    settingsMission: {
        difficulty: null, 
        duration: null,
        exitOnFull: null,
        exitOnMaxDifficulty: null,
        exitOnMaxDepth: null,
        exitOnItemsCritical: null,
        lowDurabilityWeaponSwith: null,
        collectTokens: null,
        collectMaterials: null,
        teleportTokens: null,
        teleportMaterials: null,
        teleportEquipment: null,
        behaviour: null,
        hide: null,
        safeEquipment: null,
        safeMaterials: null,
    }
}

const sdStateReducers = (state = initialState, action) => {
    switch (action.type) {
        case "MISSION_START_STATE":
            return {
                ...state,
                missionOpen: action.missionOpen,
                missionName: action.missionName,
                exitMissionModal: action.exitMissionModal,
                statusMissions: action.statusMissions
                };

        case "SEASONS_PASS_SELECTING":
            return {...state, seasonPassSelecting: action.seasonPassSelecting};
            
        case "SETTINGS_MISSION":
            return {...state, settingsMission: action.settingsMission};
        default:
            return state
    }
};

export default sdStateReducers
